import QuickRepliesStore from "./QuickRepliesStore";
export default QuickRepliesStore;
